/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

export const form = {
  'main-cover': null, // VALUE NOT CAPTURED ON ONLINE FORM THIS IS JUST FOR TESTING
  'cover-options': {
    gmd5000: null,
    gmd10000: null,
    gmd15000: null,
    gmd20000: null,
    gmd30000: null,
    gmd40000: null,
    gmd50000: null,
  },
  'one-year-memorial': null,
  'cash-bonus': null,
  'inflation-protector': null,
  'lives-assured': [],
  'life-assured-identification': {
    'first-names': null,
    surname: null,
    'idpassport-number': null,
    'id-type-radio-group': {
      drivers: null,
      passport: null,
      'voter-id': null,
      national: null,
    },
    'date-of-birth': null,
    title: null,
    'marital-status': null,
    nationality: null,
    gender: null,
    occupation: null,
  },
  'life-assured-identification-type': {
    drivers: null,
    passport: null,
    'voter-id': null,
    national: null,
  },
  'life-assured-contact-details': {
    'cell-phone': null,
    email: null,
  },
  'life-assured-postal-address': {
    addressee: null,
    'po-box-or-private-bag': null,
    town: null,
    region: null,
    street: null,
    suburb: null,
    building: null,
  },
  'spouse-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    gender: null,
    title: null,
    'cell-phone': null,
  },
  'spouse-identification-type': {
    drivers: null,
    passport: null,
    'voter-id': null,
    national: null,
  },
  'spouse-is-trustee': null,
  'trustee-identification': {
    'first-names': null,
    surname: null,
    'idpassport-number': null,
    'date-of-birth': null,
    title: null,
    gender: null,
    relationship: null,
    'cell-phone': null,
  },
  'debit-order': null,
  'stop-order': null,
  'payment-start-date': null,
  'payment-frequency': {
    monthly: null,
    quarterly: null,
    yearly: null,
  },
  'payer-signature': null,
  'payment-bank-details': {
    'account-holder-name': null,
    'account-type': null,
    'account-entity-name': null,
    'account-branch-name': null,
    'account-number': null,
  },
  'payment-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
  },
  documents: {
    'id-document': [],
  },
  'acceptance-signature': null,
  'application-acceptance-date': null,
  'application-accepted': null,
}
